<script setup>
import { ref, watchEffect } from 'vue';
import { PhxTabPanel, PhxTabs } from '@phx-styleguides/iwc';
import { get } from 'lodash-es';
import ProductSlider from '@maison/components/organisms/slider/ProductSlider.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  contentId: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  tabs: {
    type: Array,
    required: true,
  },
  hasAnimateGroupReveal: {
    type: Boolean,
    default: false,
  },
});

const currentTab = ref('');

const onTabChange = (tab) => {
  currentTab.value = tab;
};

watchEffect(() => {
  currentTab.value = get(props.tabs, '0.id', '');
});
</script>

<template>
  <div
    class="center grid__items grid-layout grid--spacing-3 center--spacing-3 center--sizing-3xl size-filters__tabs-wrapper"
  >
    <p :class="['size-filters__title', { 'fade-in': hasAnimateGroupReveal }]">{{ title }}</p>

    <phx-tabs
      :id="id"
      layout="start"
      :class="['size-filters__tabs', { 'fade-in': hasAnimateGroupReveal }]"
      :teleport-target="`#${contentId}`"
      :value="currentTab"
      :show-indicator="false"
      @change="onTabChange"
    >
      <template v-for="(tab, index) in tabs" :key="tab.id">
        <phx-tab-panel :id="tab.id" :label="tab.label">
          <product-slider v-bind="tab.slider" :class="{ 'fade-in-up': hasAnimateGroupReveal && index === 0 }" />
        </phx-tab-panel>
      </template>
    </phx-tabs>
  </div>
</template>
